<template>
  <label class="Checkbox" :class="{ 'is--collapse' : isCollapse }">
    <input :id="id" type="checkbox" @change="onChange" :name="name" :checked="modelValue" :required="!!required" :disabled="!!disabled">
    <div class="Checkbox__custom">
      <Icon name="check" />
    </div>
    <span v-if="label" class="Checkbox__label" v-html="label"></span>
    <Icon v-if="isCollapse" name="dropdown-arrow"/>
    <ToolTip v-if="tooltip" :content="tooltip" from="top"/>

  </label>
</template>

<script>
  import Icon from '@components/Icon'
  import ToolTip from "@components/ToolTip";

  export default {
    props : [ 'label', 'id', 'name', 'modelValue', 'required', 'isCollapse', 'tooltip', 'disabled'],
    components: { Icon, ToolTip },
    methods: {
      onChange(event){
        this.$emit('update:modelValue', event.target.checked)
      }
    }
  }
</script>

<style lang="scss">
@import "~@sass/components/form/_Checkbox.scss";
</style>
